import { Idea, IdeaMetricTag } from './idea';

export type MetricUnitType = 'QUANTITATIVE' | 'QUALITATIVE';

export interface IdeaMetric {
  id: string;
  idea: Idea;
  project: MetricProject;
  metric: MetricItem;
  target: number;
  result: number;
  metricType: IdeaMetricTag;
}

export interface MetricItem {
  id: string;
  name: string;
  description?: string;
  unit?: MetricUnit;
}

export const MetricUnitType = {
  QUANTITATIVE: 'QUANTITATIVE',
  QUALITATIVE: 'QUALITATIVE',
};

export interface MetricUnit {
  id: string;
  label: string;
  type: MetricUnitType;
}

export interface MetricProject {
  id: string;
  name: string;
}

export interface BaselineItem {
  id?: string;
  metric?: MetricItem;
  project?: MetricProject;
  baseline?: number;
}

export interface Project {
  id: string;
  name: string;
}

export interface Driver {
  id: string;
  driver: string;
}

export interface MetricTrigger {
  id: string;
  type: string;
  phaseId: string;
  interval: string;
}
